// 组织和用户
export default [
  {
    path: '/organization',
    redirect: '/organization/org',
  },

  // 组织
  {
    path: '/organization/org',
    name: 'organization-org',
    component: () => import(/* webpackChunkName: "org" */ '@/views/organization/org/Index.vue'),
    meta: { title: '会员/企业管理' },
  },
  {
    path: '/organization/org/add',
    name: 'organization-org-add',
    component: () => import(/* webpackChunkName: "org" */ '@/views/organization/org/add/Add.vue'),
    meta: { title: '会员/企业管理' },
  },
  {
    path: '/organization/org/detail/:id',
    name: 'organization-org-detail',
    component: () => import(/* webpackChunkName: "org" */ '@/views/organization/org/detail/Detail.vue'),
    meta: { title: '会员/企业管理' },
  },
  {
    path: '/organization/org/edit/:id',
    name: 'organization-org-edit',
    component: () => import(/* webpackChunkName: "org" */ '@/views/organization/org/edit/Edit.vue'),
    meta: { title: '会员/企业管理' },
  },
  {
    path: '/organization/org/auth/:id',
    name: 'organization-org-auth',
    component: () => import(/* webpackChunkName: "org" */ '@/views/organization/org/auth/Index.vue'),
    meta: { title: '会员/企业管理' },
  },
  {
    path: '/organization/org/competitor/:id',
    name: 'organization-org-competitor',
    component: () => import(/* webpackChunkName: "org" */ '@/views/organization/org/competitor/Index.vue'),
    meta: { title: '会员/企业管理' },
  },
  {
    path: '/organization/org/contact/:id',
    name: 'organization-org-contact',
    component: () => import(/* webpackChunkName: "org" */ '@/views/organization/org/contact/Index.vue'),
    meta: { title: '会员/企业管理' },
  },
  {
    path: '/organization/org/upgrade/:id',
    name: 'organization-org-upgrade',
    component: () => import(/* webpackChunkName: "org" */ '@/views/organization/org/upgrade/Index.vue'),
    meta: { title: '会员/企业管理' },
  },
  {
    path: '/organization/org/:id/sub-org',
    name: 'organization-org-sub',
    component: () => import(/* webpackChunkName: "org" */ '@/views/organization/org/sub/Index.vue'),
    meta: { title: '会员/企业管理' },
  },
  {
    path: '/organization/org/:id/sub-org/auth/:subOrgId',
    name: 'organization-org-sub-auth',
    component: () => import(/* webpackChunkName: "org" */ '@/views/organization/org/sub-auth/Index.vue'),
    meta: { title: '会员/企业管理' },
  },

  // 角色
  // {
  //   path: '/organization/role',
  //   name: 'org-role',
  //   component: () => import(/* webpackChunkName: "org" */ '@/views/organization/role/Index.vue'),
  //   meta: { title: '角色管理' },
  // },
  // {
  //   path: '/organization/role/add',
  //   name: 'org-role-add',
  //   component: () => import(/* webpackChunkName: "org" */ '@/views/organization/role/Add.vue'),
  //   meta: { title: '角色管理' },
  // },
];
